import { render, staticRenderFns } from "./workflow.vue?vue&type=template&id=28c02d82&scoped=true"
import script from "./workflow.vue?vue&type=script&lang=js"
export * from "./workflow.vue?vue&type=script&lang=js"
import style0 from "./workflow.vue?vue&type=style&index=0&id=28c02d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c02d82",
  null
  
)

export default component.exports